import { title } from "assets/jss/material-kit-react.jsx";

const workStyle = {
  section: {
    padding: "35px 0"
  },
  title: {
    ...title,
    marginBottom: "20px",
    marginTop: "17px",
    minHeight: "30px",
    textDecoration: "none",
    textAlign: "center"
  },
   icons: {
    width: "50px",
    height: "35px",
    marginRight: "3px",
    color: "#000",
  },
   right: {
    padding: "5px 0",
    margin: "0",
    float: "right!important"
  },
  description: {
    color: "#000",
    textAlign: "justify",
    textJustify: "auto",
    padding: "3px",
  },
  desc: {
    color: "gray",
    textAlign: "justify",
    textJustify: "auto",
       fontSize: "15px",
  },
  textCenter: {
    textAlign: "center"
  },
  textArea: {
    marginRight: "15px",
    marginLeft: "15px"
  },
  maps: {
    width: "600px",
    height: "100%",
    frameborder: '0',
    border: '0',

  }
};
 
export default workStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx